import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { ErrorUserData } from "../models/ErrorMessage/ErrorUserData";

const mailUrlPrefix = "mail";

export const mailApi = createApi({
  reducerPath: "mailApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    sendErrorReport: build.mutation<ErrorUserData, ErrorUserData>({
      query: (errorUserData) => ({
        url: `${mailUrlPrefix}/send`,
        method: "post",
        data: errorUserData,
      }),
    }),
  }),
});

export const { useSendErrorReportMutation } = mailApi;
